import { Component, EventEmitter, inject, Output } from '@angular/core';
import { AuthApiService } from '../../../core/services/auth/auth-api.service';
import { Router } from '@angular/router';
import { FormBuilder, FormControl, NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgClass, NgOptimizedImage } from '@angular/common';
import { EMAIL_REGEX, GITHUB_AUTH_URL, MIN_PASSWORD_LENGTH, PASSWORD_REGEX } from '../constant/auth.constant';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs';

@Component({
  selector: 'app-user-login',
  standalone: true,
  imports: [ReactiveFormsModule, NgClass, NgOptimizedImage],
  templateUrl: './user-login.component.html',
  styleUrl: '../user-authentification.component.scss',
})
export class UserLoginComponent {
  @Output() loginSuccess = new EventEmitter<void>();
  @Output() openRegister = new EventEmitter<void>();
  @Output() forgotPasswordRequest = new EventEmitter<string>();

  #authService = inject(AuthApiService);
  #router = inject(Router);
  #toast = inject(ToastrService);
  #fb: NonNullableFormBuilder = inject(FormBuilder).nonNullable;

  isSubmitted = false;
  public passwordVisible = false;
  public confirmPasswordVisible = false;

  loginForm = this.#fb.group({
    email: ['', [Validators.required, Validators.pattern(EMAIL_REGEX)]],
    password: ['', [Validators.required, Validators.minLength(MIN_PASSWORD_LENGTH), Validators.pattern(PASSWORD_REGEX)]],
  });

  get email(): FormControl<string> {
    return this.loginForm.controls.email;
  }

  get password(): FormControl<string> {
    return this.loginForm.controls.password;
  }

  public togglePasswordVisibility(field: 'password' | 'confirmPassword'): void {
    if (field === 'password') {
      this.passwordVisible = !this.passwordVisible;
    } else if (field === 'confirmPassword') {
      this.confirmPasswordVisible = !this.confirmPasswordVisible;
    }
  }

  login(): void {
    this.isSubmitted = true;
    this.loginForm.markAllAsTouched();

    const { email, password } = this.loginForm.value;

    if (!email || !password || this.loginForm.invalid) return;

    this.#authService
      .login$({ email, password })
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.#toast.success('Connexion réussie !', 'Succès');
          this.#router.navigate(['']);
          this.loginSuccess.emit();
        },
        error: err => {
          this.#toast.error(err.message, 'Échec de la connexion');
        },
      });
  }

  loginWithGitHub(): void {
    window.location.href = GITHUB_AUTH_URL;
  }

  onOpenRegister(): void {
    this.openRegister.emit();
  }

  onForgotPassword(): void {
    this.forgotPasswordRequest.emit(this.email.value);
  }
}
